import { render, staticRenderFns } from "./EnviromentView.vue?vue&type=template&id=33ef8fc0&scoped=true&"
import script from "./EnviromentView.vue?vue&type=script&lang=js&"
export * from "./EnviromentView.vue?vue&type=script&lang=js&"
import style0 from "./EnviromentView.vue?vue&type=style&index=0&id=33ef8fc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ef8fc0",
  null
  
)

export default component.exports